var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWikiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#D2F3E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.16 22.26L33.36 35.36L31.28 36.38L28.1 26.96L25.12 35.36L23.04 36.38L17.9 22.22L16 21.08L16.4 20.28H21.88V20.9L20.42 22L24.58 33.72L27.56 25.4L26.48 22.2L24.64 21.08L25.04 20.28H30.92V20.9L29.14 22.28L32.86 33.68L36.98 22.28L33.42 21.08L33.82 20.28H39.9V20.9L38.16 22.26Z",
    fill: "#02080E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiIcon);
export default __webpack_public_path__ + "static/media/wiki_icon.660358aee80141b33bc1d0cac0f19c92.svg";
export { ForwardRef as ReactComponent };